import classNames from "classnames"
import { PropsWithChildren } from "react"

type Props = PropsWithChildren<{
  id?: string
  className?: string
  centered?: boolean
}>

/**
 * Wraps child components. It adds padding and a white background (et cetera)
 * similar to being on paper.
 */
export const Paper = ({ children, className, centered = true, id, ...props }: Props) => (
  <div
    id={id}
    className={classNames(
      "flex flex-col gap-4 rounded-2xl border border-gray-100 bg-white p-4 lg:p-10",
      className,
      centered ? "items-center justify-center" : ""
    )}
    {...props}
  >
    {children}
  </div>
)
